import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import { profile, devConfig } from 'config/config'; // Importing profile and devConfig from configuration

/**
 * Class representing a view for filtering reports.
 * @extends JetView
 */
export default class FilterReportsView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const screen = this.app.config.size; // Screen size configuration

        // Datepicker and BetShopId combo configuration
        const fecha = {
            margin: 5,
            minWidth: 200,
            cols: [
                {
                    view: 'text', // Datepicker input
                    name: 'Datepicker',
                    id: 'Datepicker',
                    css: 'reportrange',
                    readonly: true, // Read-only input
                    label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha'), // Label with icon
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '), // Placeholder text
                },
                {
                    view: 'combo', // Combo box for BetShop selection
                    name: 'BetShopId',
                    label: "<span class='icon-shop'></span>" + _('Punto de Venta'), // Label with icon
                    hidden: !devConfig.getPermAction('filterByBetShop', 'Add'), // Conditional visibility
                    css: 'prm-filterByBetShop',
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '), // Placeholder text
                    id: 'BetShopId',
                    options: {
                        body: {
                            // Data feed function for combo box
                            dataFeed: function (text) {
                                var vthis = this; // Reference to the current context
                                if (text.length > 2) {
                                    // Trigger data fetch if input length is greater than 2
                                    webix
                                        .ajax()
                                        .headers({
                                            'Content-type': 'application/json', // Set content type for request
                                        })
                                        .post(
                                            devConfig.geturlApi() + 'es/Select/BetShopsSelect', // API endpoint
                                            '{"Filter":"' + text + '"}', // Request body
                                            {
                                                error: function (text, data, XmlHttpRequest) {
                                                    webix.message('Error! '); // Error handling
                                                },
                                                success: function (text, data, XmlHttpRequest) {
                                                    var resp = JSON.parse(text); // Parse response
                                                    if (!resp.HasError) {
                                                        vthis.parse(resp.Data); // Populate combo box with data
                                                    }
                                                },
                                            },
                                        );
                                }
                            },
                        },
                    },
                },
            ],
        };

        // Transaction ID section configuration
        const transactionId = {
            margin: 5,
            minWidth: 200,
            rows: [],
        };

        // Upper section layout combining fecha and transactionId
        const upper_section = {
            id: 'a1',
            rows: [
                {
                    responsive: 'a1',
                    margin: 10,
                    cols: [fecha, transactionId], // Columns containing fecha and transactionId
                },
            ],
        };

        // Button configuration for actions
        const buttons = {
            margin: 10,
            minWidth: 200,
            cols: [
                {},
                {
                    view: 'button', // Clear button
                    value: _('Limpiar'), // Button label
                    autowidth: true,
                    click: () => {
                        this.getRoot().clear(); // Clear form values on click
                    },
                },
                {
                    view: 'button', // Consult button
                    value: _('Consultar'), // Button label
                    type: 'form',
                    autowidth: true,
                    click: () => {
                        const filterdata = this.getRoot().getValues(); // Get form values
                        this.app.callEvent('userAffiliates:filter', [filterdata]); // Trigger filter event
                    },
                },
            ],
        };

        // Return the complete form configuration
        return {
            view: 'form',
            rows: [upper_section, buttons], // Combine upper section and buttons
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule for form
            },
        };
    }
}

// FILE DOCUMENTED
